/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum DoorPosition {
  Right = 'RIGHT',
  Left = 'LEFT',
  Middle = 'MIDDLE'
}
